'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _KeyboardHoverOnlyDiv = require('../utils/KeyboardHoverOnlyDiv');

var _KeyboardHoverOnlyDiv2 = _interopRequireDefault(_KeyboardHoverOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_Element = require('react').babelPluginFlowReactPropTypes_proptype_Element || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var Button = function Button(props) {
  var _props$kind = props.kind,
      kind = _props$kind === undefined ? 'primary' : _props$kind,
      _props$size = props.size,
      size = _props$size === undefined ? 'sm' : _props$size,
      _props$disabled = props.disabled,
      disabled = _props$disabled === undefined ? false : _props$disabled,
      _props$negative = props.negative,
      negative = _props$negative === undefined ? false : _props$negative,
      _props$gray = props.gray,
      gray = _props$gray === undefined ? false : _props$gray,
      children = props.children,
      style = props.style,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === undefined ? false : _props$isLoading,
      _props$isLoadingBlock = props.isLoadingBlocking,
      isLoadingBlocking = _props$isLoadingBlock === undefined ? true : _props$isLoadingBlock,
      className = props.className,
      onMouseDown = props.onMouseDown,
      onBlur = props.onBlur,
      isNoStyleButton = props.isNoStyleButton,
      others = _objectWithoutProperties(props, ['kind', 'size', 'disabled', 'negative', 'gray', 'children', 'style', 'isLoading', 'isLoadingBlocking', 'className', 'onMouseDown', 'onBlur', 'isNoStyleButton']);

  if (isNoStyleButton) {
    return _react2.default.createElement(
      _KeyboardHoverOnlyDiv2.default,
      Object.assign({
        isButton: true,
        className: (0, _classnames2.default)("a-no-style-button", className),
        style: style
      }, others),
      children
    );
  } else {

    var classNames = (0, _classnames2.default)('a-btn', 'a-btn-' + kind, 'a-btn-' + size, className, {
      'a-btn-negative': negative,
      'a-btn-gray': gray,
      'a-btn-no-interaction': isLoading
    });

    return _react2.default.createElement(
      _KeyboardHoverOnlyDiv2.default,
      Object.assign({
        isButton: true,
        className: classNames,
        disabled: disabled,
        style: style,
        isLoading: isLoading,
        isLoadingBlocking: isLoadingBlocking,
        onMouseDown: onMouseDown,
        onBlur: onBlur
      }, others),
      isLoading ? _react2.default.createElement('div', { className: 'a-loading-one' }) : children
    );
  }
};

Button.propTypes = Object.assign({}, {
  /**
   * The kind of the button
   */
  kind: require('prop-types').oneOf(['primary', 'secondary', 'transparent']),

  /**
   * The size of the button
   */
  size: require('prop-types').oneOf(['sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, the button will be disabled
   */
  disabled: require('prop-types').bool,

  /**
   * If `true`, the button will be applied with negative style
   */
  negative: require('prop-types').bool,

  /**
   * if `true`, the button will be applied with gray style
   */
  gray: require('prop-types').bool,

  /**
   * if `true`, display loading icon
   */
  isLoading: require('prop-types').bool,

  /**
   * The content of the button
   */
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
}, babelPluginFlowReactPropTypes_proptype_CommonType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_CommonType);
Button.propTypes = {
  kind: _propTypes2.default.string,
  size: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  negative: _propTypes2.default.bool,
  gray: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  isNoStyleButton: _propTypes2.default.bool
};

exports.default = Button;